<template>
  <div class="vma">
    <h1>Tableau Vma</h1>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>% VMA</th>
          <th>Vitesse</th>
          <th>Allure</th>
          <th v-for="(dist, key) in distArray" :key="key">{{ dist.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="n in 12" :key="n">
          <td>{{ 5*n + 45 }}%</td>
          <td>{{ formatVitesse(calcul(5*n + 45, 1000)) }}</td>
          <td>{{ formatPace(calcul(5*n + 45, 1000)) }}</td>
          <td v-for="(dist, key) in distArray" :key="key" :class="test(n, dist)">{{ formatPace(calcul(5*n + 45, dist.dist)) }} </td>
        </tr>
      </tbody>
    </table>
    <div class="wrapSlider">
      <p>Ajuster la VMA ici:</p>
      <md-slider step="0.5" ticks min="12" max="23" :value="vma" labeled @change="vmaChanged($event)"></md-slider>
    </div>
  </div>
</template>

<script>

import '@material/web/slider/slider.js'

export default {
  name: 'VMAComponent',
  data: function() {
    return {
      vma: 15,
      distArray: [{ dist: 100, bottom: 11, top: 12, color: "orange", name:"100m" },
                  { dist: 200, bottom: 11, top: 12, color: "orange", name:"200m" },
                  { dist: 300, bottom: 10, top: 11, color: "yellow", name:"300m" },
                  { dist: 400, bottom: 10, top: 11, color: "yellow", name:"400m" },
                  { dist: 500, bottom: 9, top: 10, color: "yellow", name:"500m" },
                  { dist: 600, bottom: 9, top: 10, color: "yellow", name:"600m" },
                  { dist: 800, bottom: 8, top: 9, color: "yellow", name:"800m" },
                  { dist: 1000, bottom: 8, top: 9, color: "yellow", name:"1k" },
                  { dist: 1500, bottom: 7, top: 8, color: "green", name:"1.5k" },
                  { dist: 2000, bottom: 7, top: 8, color: "green", name:"2k" },
                  { dist: 3000, bottom: 7, top: 8, color: "green", name:"3k" },
                  { dist: 5000, bottom: 7, top: 8, color: "green", name:"5k" },
                  { dist: 10000, bottom: 8, top: 9, color: "blue", name:"10k" },
                  { dist: 21100, bottom: 7, top: 8, color: "blue", name:"Semi" },
                  { dist: 42195, bottom: 6, top: 8, color: "blue", name:"Marathon" },
                ]
    }
  }, methods: {
    calcul(percent, dist) {
      let vit = this.vma*1000*percent/100
      let pac = dist*60/vit
      return pac
    }, formatPace(min) {
      let h = Math.floor(min/60)
      let m = Math.floor(min-h*60)
      let s = Math.floor(min*60-h*3600-m*60)
      let k = ""
      if(h>0) k += h+":"
      if(m<10) k += "0"
      k += m+":"
      if(s<10) k += "0"
      k += s
      return k
    }, formatVitesse(min) {
      let vit = 60/min
      return Math.floor(vit*100)/100
    }, test(n, dist) {
      if(dist.bottom <= n && n <= dist.top) {
        return dist.color
      } else {
        return ""
      }
    }, vmaChanged(e) {
      this.vma = e.target.value
    }
  }, created() {
    let p = this.calcul(55, 1000)
    console.log(this.formatPace(p))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.vma {
  background-color: #FFECA1;
  min-height: 500px;
}

h1 {
  margin-top: 50px;
  margin-bottom: 20px;
}

table {
  margin: auto;
  width: 95vw;
  margin-bottom: 50px;
}

.wrapSlider {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
}

.wrapSlider p {
  padding-top: 15px;
}

md-slider {
  width: 500px; 
}

.orange {
  background-color: #F59236;
}

.yellow {
  background-color: #E3D246;
}

.green {
  background-color: #36B83E;
}

.blue {
  background-color: #435CE8;
  color: #fff;
}

</style>
